import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api-client.js";

interface AuditEntry {
  id: string;
  action: string;
  resourceType: string;
  resourceId: string;
  userId: string;
  createdAt: string;
  after: Record<string, unknown>;
}

interface AuditData {
  items: AuditEntry[];
  total: number;
}

export function AuditPage() {
  const [data, setData] = useState<AuditData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void (async () => {
      const res = await apiClient.get<AuditData>("/audit");
      if (res.success) setData((res).data);
      setLoading(false);
    })();
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Audit-Log</h1>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: 48, color: "var(--color-text-muted)" }}>Lade…</div>
        ) : !data || data.items.length === 0 ? (
          <div style={{ textAlign: "center", padding: 48, color: "var(--color-text-muted)" }}>Keine Einträge.</div>
        ) : (
          <>
            <div style={{ marginBottom: 12, fontSize: 13, color: "var(--color-text-muted)" }}>{data.total} Einträge gesamt</div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "2px solid var(--color-border)" }}>
                  {["Zeitpunkt", "Aktion", "Ressourcentyp", "Ressource-ID", "Benutzer"].map((h) => (
                    <th key={h} style={{ textAlign: "left", padding: "8px 12px", fontSize: 12, color: "var(--color-text-muted)", fontWeight: 600 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.items.map((log, i) => (
                  <tr key={log.id} style={{ borderBottom: "1px solid var(--color-border)", background: i % 2 === 0 ? "transparent" : "#fafafa" }}>
                    <td style={{ padding: "8px 12px", fontSize: 12, color: "var(--color-text-muted)", whiteSpace: "nowrap" }}>
                      {new Date(log.createdAt).toLocaleString("de-AT")}
                    </td>
                    <td style={{ padding: "8px 12px", fontFamily: "monospace", fontSize: 12 }}>{log.action}</td>
                    <td style={{ padding: "8px 12px", fontSize: 13 }}>{log.resourceType}</td>
                    <td style={{ padding: "8px 12px", fontFamily: "monospace", fontSize: 11, color: "var(--color-text-muted)" }}>
                      {log.resourceId.slice(0, 8)}…
                    </td>
                    <td style={{ padding: "8px 12px", fontFamily: "monospace", fontSize: 11, color: "var(--color-text-muted)" }}>
                      {log.userId.slice(0, 8)}…
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}
